import { useRootLayoutData } from "~/root";

export const useBuilder = () => {
  return useRootLayoutData().builderio;
};
